/**
 * UI elements
 */
class Bookero_UI {
  constructor() {
    this.initSmoothScroll();
    this.initFocusKeyboard();
    this.initAriaAttributes();
    this.initOpenReservationForm();
    this.initExpandContent();
    this.initScrollServicesToPlugin();
    this.initChangeLang();
  }

  initSmoothScroll () {
    $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 1000);
        }
      }
    });
  }

  initFocusKeyboard () {
    let htmlTag = $('html');

    $('body').mousedown( function() {
      htmlTag.addClass('mouse');
      htmlTag.removeClass('keyboard');
      htmlTag.attr('data-whatintent', 'mouse');
    });
      
    $('body').keydown( function(e) {
      if (e.keyCode === 9) {
        htmlTag.addClass('keyboard');
        htmlTag.removeClass('mouse');
        htmlTag.attr('data-whatintent', 'keyboard');
      }
    });
  }

  initAriaAttributes () {
    $('.edd-body').attr('aria-label', 'Options')
  }

  initOpenReservationForm () {
    let pricetable = $('.pricetable');

    if (pricetable.length) {
      $('.pricetable-row').each(function(i, item) {
        let chooseBtn = $(item).find('.btn-choose').eq(0);
        let reservationForm = $(item).find('.reservation-form').eq(0);

        chooseBtn.on('click', e => {
          e.preventDefault();
          setTimeout(() => {
            reservationForm.toggleClass('is-open');
          }, 0);
        });
      });
    }
  }

  initExpandContent () {
    $('.expand-link').each(function(i, item) {
      $(item).parent().find('.expand-content').css('height', 0);
      $(item).parent().removeClass('not-initialized');

      $(item).on("click", function (e) {
        e.preventDefault();
        var item = $(this);
        var expandContent = item.parent().find('.expand-content');
        var expandContentInner = item.parent().find('.expand-content-inner');

        expandContent.toggleClass('active');
        var newHeight = expandContentInner.outerHeight();

        if (expandContent.hasClass('active')) {
          item.text(item.attr('data-text-less'));
          expandContent.css('height', 0);

          setTimeout(function() {
            expandContent.css('height', newHeight + 'px');
          }, 0);

          setTimeout(function() {
            expandContent.css('height', 'auto');
          }, 500);
        } else {
          item.text(item.attr('data-text-more'));
          expandContent.css('height', newHeight + 'px');

          setTimeout(function() {
            expandContent.css('height', 0);
          }, 0);
        }
      });
    });
  }

  initScrollServicesToPlugin () {
    var checkButtons = document.querySelectorAll('.pricetable-row a[data-id]');

    for (var i = 0; i < checkButtons.length; i++) {
      checkButtons[i].addEventListener('click', function (e) {
        e.preventDefault();
        var serviceID = parseInt(this.getAttribute('data-id'), 10);

        if (!window.bookero_plugin_form) {
          return;
        }

        var id = window.bookero_plugin_form.getAvailableInstances()[0];

        if (id) {
          var result = window.bookero_plugin_form[id].setServiceID(serviceID);

          if (result) {
            document.querySelector('#bookero-plugin').scrollIntoView({
              behavior: "smooth", 
              block: "start", 
              inline: "nearest"
            });
          }
        }
      });
    }
  }

  initChangeLang () {
    let langList = $('.language-switcher');
    let langItem = langList.find('.lang-item');
    let currentLang = langList.find('.current-lang');

    currentLang.on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      langItem.not('.current-lang').toggleClass('is-active');

      for (let i = 0; i < langItem.length; i++) {
        this.currentMove = i;
        let move = ((25 * this.currentMove) + 25 + 'px');
        langItem.not('.current-lang').eq(i).css('top', move);
      }
    });

    $('body').on('click', function (e) {
      langItem.not('.current-lang').removeClass('is-active');
    });
  }
}